import { render, staticRenderFns } from "./SlideFormCreateWhatsapp.vue?vue&type=template&id=0e33b427&"
import script from "./SlideFormCreateWhatsapp.vue?vue&type=script&lang=js&"
export * from "./SlideFormCreateWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports